import Link from 'next/link';
import RetroIconSVG from './RetroIconSVG';

export const whatNext = {
  raffleEntry: {
    endText: 'Good luck!',
    content: [
      <RetroIconSVG fname={`trophy-confirmation`} className="trophy-icon" />,
      <RetroIconSVG fname={`mail-confirmation`} className="mail-icon" />,
      <h4 className="whatNextHeader">The winner</h4>,
      <h4 className="whatNextHeader">The results</h4>,
      <p className="whatNextInfo orderConfirmationText">
        A winner will be drawn once all entries have been sold.
      </p>,
      <p className="whatNextInfo orderConfirmationText">
        We’ll email you the results or you can check them out{' '}
        <strong>
          <Link href="/results">
            <span className="resultsLink">here</span>
          </Link>
          .
        </strong>
      </p>,
    ],
  },
  prize: {
    endText: 'Enjoy your prize!',
    content: [
      <RetroIconSVG fname={`mail-confirmation`} className="mail-icon" />,
      <RetroIconSVG fname={`question-box`} className="question-icon" />,
      <h4 className="whatNextHeader">Check your emails</h4>,
      <h4 className="whatNextHeader">Got a question?</h4>,
      <p className="whatNextInfo orderConfirmationText">
        We’ve sent you a confirmation email with all the information on your
        prize and when to expect it (be sure to also check your junk/spam folder
        if you can’t find it).
      </p>,
      <p className="whatNextInfo orderConfirmationText">
        Got a question? Feel free to send an email to{' '}
        <strong>
          <Link href="mailto:hello@daymade.co.uk">
            <span className="resultsLink">hello@daymade.co.uk</span>
          </Link>
          .
        </strong>{' '}
        and we’ll be happy to help ☺️
      </p>,
    ],
  },
  tree: {
    endText: 'Thank you for helping us help the planet!',
    content: [
      <RetroIconSVG fname={`tree-growing`} className="tree-icon" />,
      <RetroIconSVG fname={`trophy-confirmation`} className="trophy-icon" />,
      <h4 className="whatNextHeader">More on trees</h4>,
      <h4 className="whatNextHeader">Leaderboard</h4>,
      <p className="whatNextInfo orderConfirmationText">
        Find out more information on our tree planting initiative right{' '}
        <strong>
          <Link href="https://www.veritree.com">
            <span className="resultsLink">here</span>
          </Link>
          .
        </strong>
      </p>,
      <p className="whatNextInfo orderConfirmationText">
        Head over to our{' '}
        <strong>
          <Link href="/leaderboard">
            <span className="resultsLink">Leaderboard</span>
          </Link>
        </strong>{' '}
        to see where you stand and what prizes are up for grabs this month!
      </p>,
    ],
  },
  lottoEntry: {
    endText: 'Good luck!',
    content: [
      <RetroIconSVG fname={`trophy-confirmation`} className="trophy-icon" />,
      <RetroIconSVG fname={`mail-confirmation`} className="mail-icon" />,
      <h4 className="whatNextHeader">Winning numbers</h4>,
      <h4 className="whatNextHeader">The results</h4>,
      <p className="whatNextInfo orderConfirmationText">
        The winning numbers will be randomly drawn every day at 7pm.
      </p>,
      <p className="whatNextInfo orderConfirmationText">
        We’ll email you the results or you can check them out{' '}
        <strong>
          <Link href="/results">
            <span className="resultsLink">here</span>
          </Link>
          .
        </strong>
      </p>,
    ],
  },
};
